package hk.com.vr360_demo2.webapp

import cc.easyandroid.easycompose.component.DefaultComponentContext
import cc.easyandroid.easycompose.core.lifecycle.LifecycleRegistry
import cc.easyandroid.easycompose.core.lifecycle.resume
import cc.easyandroid.easycompose.core.lifecycle.stop
import cc.easyandroid.easycompose.router.webhistory.withWebHistory
import hk.com.vr360_demo2.webapp.component.AppComponent
import hk.com.vr360_demo2.webapp.component.DefaultAppComponent
import hk.com.vr360_demo2.webapp.component.ToastProvider
import hk.com.vr360_demo2.webapp.core.di.appModule
import hk.com.vr360_demo2.webapp.ui.ThemeModule
import hk.com.vr360_demo2.webapp.utils.Url
import kotlinx.browser.window
import org.koin.core.context.GlobalContext
import org.koin.core.context.startKoin
import react.Props
import react.create
import react.dom.client.createRoot
import web.dom.DocumentVisibilityState
import web.dom.ElementId
import web.dom.document
import web.dom.visible




fun main() {
    // Avoid duplicate mounting in dev reload scenarios.
    //if (window.asDynamic().__vr360_main_initialized == true) return
    //window.asDynamic().__vr360_main_initialized = true

    if (GlobalContext.getOrNull() == null) {
        startKoin {
            modules(appModule)
        }
    }

    println("cgp main start")
    val lifecycle = LifecycleRegistry()
    val root =
        withWebHistory { stateKeeper, deepLink ->
            val context = DefaultComponentContext(lifecycle, stateKeeper = stateKeeper)
            DefaultAppComponent(context, deepLinkUrl = deepLink?.let(::Url))
        }

    val container = document.getElementById(ElementId("root")) ?: error("No root element")
    lifecycle.attachToDocument()
    createRoot(container).render(ToastProvider.create {
        ThemeModule {
            App {
                this.appComponent = root
            }
        }
    })
}

private fun LifecycleRegistry.attachToDocument() {
    fun onVisibilityChanged() {
        if (document.visibilityState == DocumentVisibilityState.visible) {
            resume()
        } else {
            stop()
        }
    }

    onVisibilityChanged()
    document.asDynamic().addEventListener("visibilitychange") {
        onVisibilityChanged()
    }
}